module.exports = __webpack_public_path__ + "img/elec_bottom2_s.1b049bf0.png";